import { Component, ElementRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../../config';
import { IcbService } from '../../icb.service'
import { ErrorHandler } from '../../../shared/services/error-handler.service'
import { HttpService } from '../../../shared/services/http.service'
import { LayoutService } from '../../../layout/layout.service'
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { CommonService } from '../../../shared/services/common.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDialog, MdDialogRef } from '@angular/material';
import { dialogComponent, icbtermsDialogComponent, privacyComponent } from '../../../dialog/dialog.component';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import * as $ from 'jquery';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { Http, Headers } from '@angular/http';
import { FileUploader } from 'ng2-file-upload';
import { addNewAddressComponent } from '../../../trade/details/addNewAddress.component';
import { addNewContactComponent } from '../../../trade/details/addNewContact.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from 'ng2-translate';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'request-add',
    template: require('./data.component.html'),
    styles: [require('./data.component.scss')],
    providers: [HttpService, ErrorHandler, SessionHandler, IcbService]
})
export class t2cDataComponent implements OnInit, OnDestroy {

    t2cForm: FormGroup;
    t2cFormData: any = {};
    dialogRef: MdDialogRef<any>;
    requestFormData: any = {};
    userData: any;
    tradeId: any;
    tradeData: any = {};
    billingData: any = {};
    addressList: any = [];
    contactList: any = [];
    selectedAddress: any;
    selectedContactName: any;
    selectedContactEmail: any;
    selectedContactPhone: any;
    magList: any = [];

    // faults
    faultListOriginal: any[] = [];
    faultList: any[] = []; // UI list with displayLabel
    selectedMagId: any;
    selectedFaultId: any;

    daterange: any = {};
    purchaseDate: any;
    monthNames: any;
    modelList: any = [];

    // consumer models
    salutation: any;
    consumerFirstName: any;
    consumerLastName: any;
    consumerEmail: any;
    consumerPhone: any;
    consumerMobile: any;
    consumerStreet: any;
    consumerCity: any;
    postalCode: any;
    consumerHouseNumber: any;
    salutationList: any;
    modelNumber: any;
    isAdmin: boolean = false;
    istradePartnerId: boolean = false;
    postalPattern: any;

    // booleans
    consumerNameValid: boolean = false;
    consumerPhoneValid: boolean = false;
    consumerEmailValid: boolean = false;
    termsCheck: boolean = false;
    isIcb: boolean = false;
    URL: any = APPCONFIG.appUrlBase + '/uploadFiles';
    uploader;
    isFileUploaded: boolean = false;
    isFileUploadError: boolean = false;
    fileUrl: any = [];
    uploadedDocList: any = [];
    fileUploadResponse: any;
    enableButtons = false;

    @ViewChild('purchasedate') purchasedate: ElementRef;
    isdocument: boolean = false;

    // --- language support ---
    languages: string[] = ['English', 'French', 'Italian', 'German'];
    selectedLanguage: string = 'English';
    private langSub: Subscription;
    // ------------------------

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public Http: Http,
        private http: HttpService,
        private formBuilder: FormBuilder,
        private commonService: CommonService,
        private sessionHandler: SessionHandler,
        private dialog: MdDialog,
        private daterangepickerOptions: DaterangepickerConfig,
        private translate: TranslateService
    ) {
        if (this.http.checkSession()) {
            this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });

            if (JSON.parse(this.sessionHandler.getItem('t2cCount')) == 1) {
                this.commonService.setData(null);
                this.sessionHandler.saveItem("t2cCount", '1');
                this.sessionHandler.saveItem("t2tCount", '1');
            }

            // initialize language (try saved value)
            try {
                const saved = localStorage.getItem('appLanguage');
                if (saved && this.languages.indexOf(saved) !== -1) {
                    this.selectedLanguage = saved;
                    this.translate.use(saved);
                } else {
                    this.selectedLanguage = 'English';
                    this.translate.setDefaultLang('English');
                    this.translate.use('English');
                }
            } catch (e) {
                console.warn('Language init error', e);
            }

            this.getMagFaultDesc();

            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            try {
                this.salutationList = JSON.parse(this.sessionHandler.getItem('salutationList'));
            } catch (e) {
                this.salutationList = [];
            }
            let icbCheck = JSON.parse(this.sessionHandler.getItem('isIcb'));
            if (icbCheck) {
                this.isIcb = true;
            } else {
                this.isIcb = false;
            }
            let data = this.commonService.getData();
            if (this.userData) {
                this.tradeId = this.userData.tradePartnerId;
                if (this.userData.role && this.userData.role.length > 0) {
                    if (this.userData.role.includes('ADMIN')) {
                        this.isAdmin = true;
                    }
                }
                this.commonService.contactChange.subscribe(() => {
                    this.getContactList('new');
                });
                this.commonService.addressChange.subscribe(() => {
                    this.getAddressList();
                });
            }
            this.salutation = 1;

            this.monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
            var today = new Date();
            this.daterange.date = today.getDate();
            this.daterange.month = today.getMonth();
            this.daterange.startYear = today.getFullYear();
            if (data && data['icbRequest']) {
                this.t2cFormData = data['icbRequest'];
                if (this.isAdmin && this.t2cFormData.tradePartnerId && this.t2cFormData.tradePartnerId != null) {
                    this.tradeId = this.t2cFormData.tradePartnerId;
                    this.getTradeData();
                }
            } else {
                this.commonService.clearIcbImageData();
                this.uploadedDocList = [];
                this.isdocument = false;
            }
            this.purchaseDate = '';
            this.daterangepickerOptions.settings = {
                locale: { format: 'D-MMMM-YYYY' },
                alwaysShowCalendars: false,
                singleDatePicker: true,
                startDate: new Date(),
                maxDate: new Date(),
                opens: 'left'
            };
            if (!this.isAdmin) {
                this.getTradeData();
            }

            var country = (this.userData && this.userData.country) ? this.userData.country : null;
            if (country == 'BE') {
                this.postalPattern = /^[0-9]{4}$/; // Belgium
            } else if (country == 'NL') {
                this.postalPattern = /^[0-9]{4}[ ][A-Z]{2}$/;
            } else if (country == 'FR') {
                this.postalPattern = /^[0-9]{5}$/; // France
            } else if (country == 'DE') {
                this.salutationList = [{"id":3,"labelEnglish":"Company","labelDutch":"Bedrijf","labelFrench":"Société","labelGerman":"Firma"},{"id":2,"labelEnglish":"Mr","labelDutch":"Dhr.","labelFrench":"Monsieur","labelGerman":"Herr"},{"id":6,"labelEnglish":"Mr and Mrs","labelDutch":"Fam.","labelFrench":"Monsieur et  Madame","labelGerman":"Herr und Frau"},{"id":1,"labelEnglish":"Ms","labelDutch":"Mej.","labelFrench":"Madame","labelGerman":"Frau"}];
                this.postalPattern = /^[0-9]{5}$/; // Germany
            }

            // subscribe to global language changes (so dashboard changes reflect here)
            this.langSub = this.commonService.langChange.subscribe((lang: any) => {
                if (lang && this.languages.indexOf(lang) !== -1) {
                    this.selectedLanguage = lang;
                    try {
                        this.translate.use(lang);
                        localStorage.setItem('appLanguage', lang);
                    } catch (e) {
                        console.error('translate.use failed', e);
                    }
                    // re-map fault labels for UI
                    this.applyLanguageToFaults(lang);
                }
            });
        } else {
            this.http.showSessionError();
        }
    }

    ngOnInit() {
        this.buildForm();
        this.viewDocumets();
    }

    ngOnDestroy() {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
    }

    public selectedDate(value: any) {
        this.purchaseDate = value.start.format('D-MMMM-YYYY');
        if (this.t2cForm && this.t2cForm.controls['formPurchaseDate']) {
            this.t2cForm.controls['formPurchaseDate'].setValue(this.purchaseDate);
        }
    }

    public scrollTo() {
        $('html, body').animate({
            scrollTop: $("#createdBy").offset().top
        }, 1000);
    }

    public tradePartnerIdEmptyheck() {
        this.reset();
        if (this.tradeId != null && this.tradeId != '') {
            this.istradePartnerId = true;
        }
    }

    public buildForm() {
        this.t2cForm = this.formBuilder.group({
            pickupSame: this.formBuilder.control(this.t2cFormData.pickupSame ? this.t2cFormData.pickupSame : "true", []),
            pickupAddressId: this.formBuilder.control(this.t2cFormData.pickupAddress ? this.t2cFormData.pickupAddress : null, [Validators.required]),
            contactNameId: this.formBuilder.control(this.t2cFormData.contactName ? this.t2cFormData.contactName : null, [Validators.required]),
            contactEmailId: this.formBuilder.control(this.t2cFormData.contactEmail ? this.t2cFormData.contactEmail : null, [Validators.required]),
            contactPhoneId: this.formBuilder.control(this.t2cFormData.contactPhone ? this.t2cFormData.contactPhone : null, [Validators.required]),
            modelNumber: this.formBuilder.control(this.t2cFormData.modelNumber ? this.t2cFormData.modelNumber : null, [Validators.required]),
            serialNumber: this.formBuilder.control(this.t2cFormData.serialNumber ? this.t2cFormData.serialNumber : null, [Validators.required]),
            refCode: this.formBuilder.control(this.t2cFormData.refCode ? this.t2cFormData.refCode : null, []),
            faultId: this.formBuilder.control(this.t2cFormData.faultDescription ? this.t2cFormData.faultDescription : null, [Validators.required]),
            additionalInfo: this.formBuilder.control(this.t2cFormData.additionalInfo ? this.t2cFormData.additionalInfo : null, [Validators.required, Validators.minLength(10)]),

            deliverySame: this.formBuilder.control(this.t2cFormData.deliverySame ? this.t2cFormData.deliverySame : 'false', [Validators.required]),
            salutationId: this.formBuilder.control(this.t2cFormData.salutationId ? this.t2cFormData.salutationId : null, [Validators.required]),
            consumerFirstName: this.formBuilder.control(this.t2cFormData.consumerFirstName ? this.t2cFormData.consumerFirstName : null, [Validators.required]),
            consumerLastName: this.formBuilder.control(this.t2cFormData.consumerLastName ? this.t2cFormData.consumerLastName : null, [Validators.required]),
            consumerEmail: this.formBuilder.control(this.t2cFormData.consumerEmail ? this.t2cFormData.consumerEmail : null, [Validators.required]),
            consumerPhone: this.formBuilder.control(this.t2cFormData.consumerPhone ? this.t2cFormData.consumerPhone : null, [Validators.required]),
            consumerMobile: this.formBuilder.control(this.t2cFormData.consumerMobile ? this.t2cFormData.consumerMobile : null, [Validators.required]),
            consumerHouseNumber: this.formBuilder.control(this.t2cFormData.consumerHouseNumber ? this.t2cFormData.consumerHouseNumber : null, [Validators.required]),
            consumerStreet: this.formBuilder.control(this.t2cFormData.consumerStreet ? this.t2cFormData.consumerStreet : null, [Validators.required]),
            consumerCity: this.formBuilder.control(this.t2cFormData.consumerCity ? this.t2cFormData.consumerCity : null, [Validators.required]),
            postalCode: this.formBuilder.control(this.t2cFormData.postalCode ? this.t2cFormData.postalCode : null, [Validators.pattern(this.postalPattern)]),
            isT2C: this.formBuilder.control(this.t2cFormData.isT2C ? "true" : "false", []),
            formPurchaseDate: this.formBuilder.control(this.t2cFormData.formPurchaseDate ? this.t2cFormData.formPurchaseDate : null, [Validators.required]),
        });
        this.updateDeliveryDeatilValidation(this.t2cForm.get('isT2C').value);
        this.t2cForm.get('pickupSame').valueChanges.subscribe(data => {
            this.checkSameAddress(data);
        });
        this.t2cForm.get('isT2C').valueChanges.subscribe(data => {
            this.updateDeliveryDeatilValidation(data);
        });
        setTimeout(() => {
            if (this.purchasedate && this.purchasedate.nativeElement) {
                this.purchasedate.nativeElement.value = '';
            }
        })
    }

    updateDeliveryDeatilValidation(data) {
        if (data == 'false') {
            this.t2cForm.controls['deliverySame'].setValidators(null);
            this.t2cForm.controls['salutationId'].setValidators(null);
            this.t2cForm.controls['consumerFirstName'].setValidators(null);
            this.t2cForm.controls['consumerLastName'].setValidators(null);
            this.t2cForm.controls['consumerEmail'].setValidators(null);
            this.t2cForm.controls['consumerPhone'].setValidators(null);
            this.t2cForm.controls['consumerMobile'].setValidators(null);
            this.t2cForm.controls['consumerCity'].setValidators(null);
            this.t2cForm.controls['consumerStreet'].setValidators(null);
            this.t2cForm.controls['consumerHouseNumber'].setValidators(null);
            this.t2cForm.controls['postalCode'].setValidators(null);
        }
        if (data == 'true') {
            this.t2cForm.controls['deliverySame'].setValidators([Validators.required]);
            this.t2cForm.controls['salutationId'].setValidators([Validators.required]);
            this.t2cForm.controls['consumerFirstName'].setValidators([Validators.required]);
            this.t2cForm.controls['consumerLastName'].setValidators([Validators.required]);
            this.t2cForm.controls['consumerEmail'].setValidators([Validators.required]);
            this.t2cForm.controls['consumerPhone'].setValidators([Validators.required]);
            this.t2cForm.controls['consumerMobile'].setValidators([Validators.required]);
            this.t2cForm.controls['consumerCity'].setValidators([Validators.required]);
            this.t2cForm.controls['consumerStreet'].setValidators([Validators.required]);
            this.t2cForm.controls['consumerHouseNumber'].setValidators([Validators.required]);
            this.t2cForm.controls['postalCode'].setValidators([Validators.required]);
        }
        if (!this.isAdmin) {
            this.t2cForm.controls['pickupAddressId'].setValidators(null);
        }
        this.t2cForm.controls['deliverySame'].updateValueAndValidity();
        this.t2cForm.controls['salutationId'].updateValueAndValidity();
        this.t2cForm.controls['consumerFirstName'].updateValueAndValidity();
        this.t2cForm.controls['consumerLastName'].updateValueAndValidity();
        this.t2cForm.controls['consumerEmail'].updateValueAndValidity();
        this.t2cForm.controls['consumerPhone'].updateValueAndValidity();
        this.t2cForm.controls['consumerMobile'].updateValueAndValidity();
        this.t2cForm.controls['consumerCity'].updateValueAndValidity();
        this.t2cForm.controls['consumerStreet'].updateValueAndValidity();
        this.t2cForm.controls['consumerHouseNumber'].updateValueAndValidity();
        this.t2cForm.controls['postalCode'].updateValueAndValidity();
        this.t2cForm.controls['pickupAddressId'].updateValueAndValidity();
    }

    searchModelNumber = (data: any): Observable<any[]> => {
        let url: string = APPCONFIG.appUrl + '/serviceOrder/v1/getModelNumber?key=AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y&modelNumber=' + data;
        let headers = new Headers({ 'apiKey': 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y', 'access-token': this.sessionHandler.getItem('token') });

        if (data) {
            return this.Http.get(url, { headers: headers })
                .map(res => {
                    let json = res.json();
                    if (json.items) {
                        this.modelList = json.items;
                        return json.items;
                    } else {
                        this.modelNumber = '';
                        return [];
                    }
                })
        } else {
            return Observable.of([]);
        }
    }

    checkModelNumber() {
        if (this.modelList && this.modelList.length > 0) {
            let check = false;
            for (let m in this.modelList) {
                if (this.modelList[m] == this.modelNumber) {
                    check = true;
                }
            }
            if (check == false) {
                this.modelNumber = '';
            }
        }
    }

    isNextDisabled(): boolean {
        return !this.t2cForm.valid || !this.termsCheck || !this.hasUploadedFiles();
    }

    hasUploadedFiles(): boolean {
        const files = this.commonService.getIcbImageData();
        return files && files.length > 0;
    }

    public reset() {
        this.requestFormData = {};
        this.t2cFormData = {};
        if (this.isAdmin) {
            this.tradeData = {};
            this.billingData = {};
        }
        this.purchaseDate = '';

        this.t2cForm.controls['pickupSame'].setValue('true');

        this.commonService.clearIcbImageData();
        this.t2cForm.controls['modelNumber'].setValue(null);
        this.t2cForm.controls['serialNumber'].setValue(null);
        this.t2cForm.controls['refCode'].setValue(null);
        this.t2cForm.controls['faultId'].setValue(null);
        this.t2cForm.controls['additionalInfo'].setValue(null);
        this.t2cForm.controls['deliverySame'].setValue('false');
        this.t2cForm.controls['consumerFirstName'].setValue(null);
        this.t2cForm.controls['consumerLastName'].setValue(null);
        this.t2cForm.controls['consumerEmail'].setValue(null);
        this.t2cForm.controls['consumerPhone'].setValue(null);
        this.t2cForm.controls['consumerMobile'].setValue(null);
        this.t2cForm.controls['consumerHouseNumber'].setValue(null);
        this.t2cForm.controls['consumerStreet'].setValue(null);
        this.t2cForm.controls['consumerCity'].setValue(null);
        this.t2cForm.controls['postalCode'].setValue(null);
        this.t2cForm.controls['isT2C'].setValue('false');

        this.t2cForm.controls['formPurchaseDate'].setValue(null);
        this.selectedAddress = null;
        this.selectedContactName = null;
        this.selectedContactEmail = null;
        this.selectedContactPhone = null;
        this.modelNumber = '';
        this.setDefaultData();
        this.enableButtons = false;
        let imgs = [];
        this.commonService.setIcbImageData(imgs);
        this.uploadedDocList = this.commonService.getIcbImageData();
        this.isdocument = false;
    }

    public getTradeData() {
        if (this.tradeId) {
            this.tradeId = this.tradeId.replace(/\s/g, "");
        }
        if (this.tradeId) {
            this.http.getRequest('tradePartnerDetails/v1/get?tradePartnerId=' + this.tradeId)
                .subscribe(
                    res => {
                        this.saveTradeData(res);
                    },
                    err => {
                        if (err && err.status != 0) {
                            this.dialogRef = this.dialog.open(dialogComponent);
                            this.dialogRef.componentInstance.msg = err;
                        }
                        this.http.onEnd();
                    });
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Trade Partner Id should not be empty';
        }
    }

    public saveTradeData(res) {
        if (res.status == "Success" && res.tradePartner) {

            this.tradeData = res.tradePartner;
            this.requestFormData['tradeData'] = this.tradeData;
            this.commonService.setData(this.requestFormData);
            this.enableButtons = true;
            this.getAddressList();
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Trade data not found.To Create new request Please save default trade details first.';
            this.dialogRef.afterClosed().subscribe(result => {
                this.router.navigateByUrl('/app/trade/details');
                this.dialogRef = null;
            });
            this.http.onEnd();
        }
    }

    public getAddressList() {
        let data = {};
        data['tradePartnerId'] = this.tradeId;
        data['salesOrgId'] = APPCONFIG.salesOrgId;
        data['isICBUser'] = this.isIcb;
        this.http.postRequest(data, 'tradePartnerDetails/v1/invoiceBillingAddress')
            .subscribe(
                res => {
                    this.saveAddressList(res);
                    this.http.onEnd();

                },
                err => {

                    if (err && err.status != 0) {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                    }
                    this.http.onEnd();
                });
    }

    public getContactList(action = null) {
        this.http.getRequest('userOperationsApi/v1/getContacts?tradePartnerId=' + this.tradeId)
            .subscribe(
                res => {
                    this.saveContactList(res, action)
                    this.http.onEnd();
                },
                err => {
                    if (err && err.status != 0) {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                    }
                    this.http.onEnd();
                });
    }

    public saveAddressList(res) {
        this.getContactList();
        if (res.billingAddress) {
            this.billingData = res.billingAddress;
        }
        if (res.shippingAddressList && res.shippingAddressList.length > 0) {
            this.addressList = res.shippingAddressList;
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'No address found.';
            this.http.onEnd();
        }
        this.http.onEnd();
    }

    public saveContactList(res, action) {
        if (res.items && res.items.length > 0) {
            this.contactList = res.items;
            if (action == 'new') {
                this.selectedContactName = this.contactList[this.contactList.length - 1].id;
                this.selectedContactEmail = this.contactList[this.contactList.length - 1].id;
                this.selectedContactPhone = this.contactList[this.contactList.length - 1].id;
            } else {
                this.setDefaultData();
            }
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'To create new request please save contact details first.';
            this.http.onEnd();
            this.router.navigateByUrl('/app/trade/details');
        }
        this.http.onEnd();
    }

    public setDefaultAddress() {
        if (this.addressList && this.billingData) {
            let length = this.addressList.length;
            let count = 0;
            for (let i in this.addressList) {
                if (this.addressList[i].address == this.billingData.invoiceAddress) {
                    this.selectedAddress = this.addressList[i].id;
                    let rawData = this.t2cForm.getRawValue();
                    if (rawData.pickupSame != "true") {
                        this.t2cForm.controls['pickupSame'].setValue("true");
                    }
                    this.t2cForm.get('pickupAddressId').disable();
                    return true;
                } else {
                    count++;
                }
            }
            if (count == length) {
                this.t2cForm.controls['pickupSame'].setValue("false");
            }
        }
    }

    public checkSameAddress(check) {
        if (check == 'true') {
            let res = this.setDefaultAddress();
            if (res) {
                this.t2cForm.get('pickupAddressId').disable();
            }
        } else {
            this.t2cForm.get('pickupAddressId').enable();
            if (this.t2cFormData.pickupAddressId) {
                this.selectedAddress = this.t2cFormData.pickupAddressId;
            } else if (this.tradeData.addressId) {
                let check = false;
                for (let a in this.addressList) {
                    if (this.addressList[a].id == this.tradeData.addressId) {
                        this.selectedAddress = this.tradeData.addressId;
                        check = true;
                    }
                }
                if (!check && this.addressList && this.addressList.length > 0) {
                    let length = this.addressList.length;
                    this.selectedAddress = this.addressList[length - 1].id;
                }
            } else if (this.addressList && this.addressList.length > 0) {
                let length = this.addressList.length;
                this.selectedAddress = this.addressList[length - 1].id;
            }
        }
    }

    public addSerialValidation() {
        this.requestFormData['icbRequest'] = this.t2cForm.getRawValue();
        if (this.requestFormData['icbRequest'].serialNumber) {
            this.t2cForm.controls['serialNumber'].setValue(this.requestFormData['icbRequest'].serialNumber.toUpperCase());
            if (!this.SerialValidation(this.requestFormData['icbRequest'].serialNumber)) {
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'Invalid Serial Number. Please enter valid serial number of length 9 or 10.';
                this.t2cForm.controls['serialNumber'].setValue(null);
            }
        }
    }
    public addPostalCodeValidation() {
        if (this.userData && (this.userData.country == 'BE' || this.userData.country == 'NL' || this.userData.country == 'FR' || this.userData.country == 'DE')) {
            if (this.postalPattern && this.postalPattern.test && this.postalPattern.test(this.postalCode) == false) {
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'Invalid Postal Code.';
                this.postalCode = "";
            }
        }
    }
    
public SerialValidation(value: string) {
    if (!value) return false;

    if (value.length === 9) {
        return /^[Ww][A-Za-z0-9]([0-4][0-9]|5[0-3])\d{5}$/.test(value);
    } else if (value.length === 10) {
        return /^[WwYyDd][A-Za-z][A-Za-z0-9]([0-4][0-9]|5[0-3])\d{5}$/.test(value);
    } else {
        return false;
    }
}


    public consumerContactValidation(field, evt) {
        if (field == 'name') {
            if (/^[a-z0-9_ -]+$/i.test(evt) == false) {
                this.consumerNameValid = false;
            } else {
                this.consumerNameValid = true;
            }
        }
        if (field == 'phone') {
            if (/^[0-9+\s]+$/i.test(evt) == false) {
                this.consumerPhoneValid = false;
            } else {
                this.consumerPhoneValid = true;
            }
        }
        if (field == 'email') {
            if (/^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/.test(evt) == false) {
                this.consumerEmailValid = false;
            } else {
                this.consumerEmailValid = true;
            }
        }
    }

    public setDefaultData() {

        if (Object.keys(this.t2cFormData).length > 0) {
            if (this.t2cFormData.contactNameId) {
                this.selectedContactName = this.t2cFormData.contactNameId;
            }
            if (this.t2cFormData.contactEmailId) {
                this.selectedContactEmail = this.t2cFormData.contactEmailId;
            }
            if (this.t2cFormData.contactPhoneId) {
                this.selectedContactPhone = this.t2cFormData.contactPhoneId;
            }
            if (this.t2cFormData.pickupAddressId) {
                this.selectedAddress = this.t2cFormData.pickupAddressId;
            }
            if (this.magList) {
                for (let m in this.magList) {
                    if (this.magList[m].magKey == this.t2cFormData.magKey) {
                        this.selectedMagId = this.magList[m].magKey;
                    }
                }
            }
            if (this.faultList) {
                for (let f in this.faultList) {
                    if (this.faultList[f].faultId == this.t2cFormData.faultId) {
                        this.selectedFaultId = this.faultList[f].faultId;
                    }
                }
            }
            if (this.salutationList) {
                for (let s in this.salutationList) {
                    if (this.salutationList[s].id == this.t2cFormData.salutationId) {
                        this.salutation = this.salutationList[s].id;
                    }
                }
            }
            this.consumerFirstName = this.t2cFormData.consumerFirstName;
            this.consumerLastName = this.t2cFormData.consumerLastName;
            this.consumerEmail = this.t2cFormData.consumerEmail;
            this.consumerPhone = this.t2cFormData.consumerPhone;
            this.consumerMobile = this.t2cFormData.consumerMobile;
            this.consumerHouseNumber = this.t2cFormData.consumerHouseNumber;
            this.consumerStreet = this.t2cFormData.consumerStreet;
            this.consumerCity = this.t2cFormData.consumerCity;
            this.postalCode = this.t2cFormData.postalCode;
            this.modelNumber = this.t2cFormData.modelNumber;
            this.purchaseDate = this.t2cFormData.purchaseDate;
            this.daterangepickerOptions.settings = {
                locale: { format: 'D-MMMM-YYYY' },
                alwaysShowCalendars: false,
                singleDatePicker: true,
                startDate: new Date(this.purchaseDate),
                maxDate: new Date(),
                opens: 'left'
            };
        } else if (this.tradeData) {
            if (this.contactList && this.contactList.length > 0) {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactName == this.tradeData.contactName) {
                        this.selectedContactName = this.contactList[i].id;
                    }
                    if (this.contactList[i].contactEmail == this.tradeData.contactEmail) {
                        this.selectedContactEmail = this.contactList[i].id;
                    }
                    if (this.contactList[i].contactPhone == this.tradeData.contactPhone) {
                        this.selectedContactPhone = this.contactList[i].id;
                    }
                }
            }
            if (this.addressList && this.addressList.length > 0) {
                for (let i in this.addressList) {
                    if (this.addressList[i].address == this.billingData.invoiceAddress) {
                        this.selectedAddress = this.addressList[i].id;
                    }
                }
            }
        }
        if (Object.keys(this.t2cFormData).length > 0) {
            if (this.t2cFormData.pickupSame == true || this.t2cFormData.pickupSame == 'true') {
                this.t2cForm.controls['pickupSame'].setValue("true");
                this.checkSameAddress('true');
            } else if (this.t2cFormData.pickupSame == false || this.t2cFormData.pickupSame == 'false') {
                this.t2cForm.controls['pickupSame'].setValue("false");
                this.checkSameAddress('false');
            }
        } else {
            this.setDefaultAddress();
        }
        this.http.onEnd();
    }

    public setFormDetails() {
        this.requestFormData['icbRequest'].purchaseDate = this.purchaseDate;
        this.requestFormData['icbRequest'].tradeName = (this.tradeData.name1 ? this.tradeData.name1 : '') + (this.tradeData.name2 ? this.tradeData.name2 : '');
        this.requestFormData['icbRequest'].tradePartnerId = this.tradeId;
        this.requestFormData['icbRequest'].billingAddress = this.billingData.invoiceAddress;
        this.requestFormData['icbRequest'].consumerCountry = this.userData ? this.userData.country : null;

        if (this.addressList) {
            for (let i in this.addressList) {
                if (this.addressList[i].id == this.requestFormData['icbRequest'].pickupAddressId) {
                    this.requestFormData['icbRequest'].pickupAddress = this.addressList[i].address;
                    this.requestFormData['icbRequest'].tradePartnerAddress = this.addressList[i];
                }
            }
        }
        if (this.contactList) {
            for (let i in this.contactList) {
                if (this.contactList[i].id == this.requestFormData['icbRequest'].contactNameId) {
                    this.requestFormData['icbRequest'].contactName = this.contactList[i].contactName;
                }
                if (this.contactList[i].id == this.requestFormData['icbRequest'].contactEmailId) {
                    this.requestFormData['icbRequest'].contactEmail = this.contactList[i].contactEmail;
                }
                if (this.contactList[i].id == this.requestFormData['icbRequest'].contactPhoneId) {
                    this.requestFormData['icbRequest'].contactPhone = this.contactList[i].contactPhone;
                }
            }
        }
        if (this.salutationList) {
            for (let s in this.salutationList) {
                if (this.salutationList[s].id == this.requestFormData['icbRequest'].salutationId) {
                    // store English label for backend if needed; otherwise you could store label for selectedLanguage
                    this.requestFormData['icbRequest'].salutation = this.salutationList[s].labelEnglish;
                }
            }
        }
        if (this.magList) {
            for (let m in this.magList) {
                if (this.magList[m].magKey == this.requestFormData['icbRequest'].magKey) {
                    this.requestFormData['icbRequest'].mag = this.magList[m].labelEnglish;
                }
            }
        }
        if (this.faultListOriginal && this.requestFormData['icbRequest'].faultId) {
            // find original fault by id and pick label according to selectedLanguage
            for (let f of this.faultListOriginal) {
                if (f.faultId == this.requestFormData['icbRequest'].faultId) {
                    // pick display label for currently selected language (fallbacks handled inside helper)
                    this.requestFormData['icbRequest'].faultDescription = this.getFaultLabel(f, this.selectedLanguage);
                    break;
                }
            }
        }
        return true;
    }
    public goToNextPage() {
        if (this.termsCheck) {
            if (!this.commonService.getIcbImageData() || this.commonService.getIcbImageData().length === 0) {
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'Please upload at least one document to proceed.';
                return;
            }
            this.purchaseDate = this.purchaseDate ? this.purchaseDate.replace(/\s/g, "") : this.purchaseDate;
            if (this.purchaseDate) {
                this.requestFormData['icbRequest'] = this.t2cForm.getRawValue();
                if (this.requestFormData['icbRequest'].isT2C == 'true') {
                    this.requestFormData['icbRequest'].isT2C = true
                } else {
                    this.requestFormData['icbRequest'].isT2C = false;
                }
                this.setFormDetails();
                this.sessionHandler.saveItem("t2cCount", '2');
                this.commonService.setData(this.requestFormData);
                this.router.navigateByUrl('/app/icb/consumer/summary');
            } else {
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'Please select the Purchase date to proceed.';
            }
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Please select the checkbox to proceed.';
        }
    }
    public saveBPresponse(res) {
        if (res.status == 'Success') {
            this.requestFormData['icbRequest'].applianceId = res.applianceId;
            this.requestFormData['icbRequest'].dealerId = res.bpRegId;
            this.sessionHandler.saveItem("t2cCount", '2');
            this.commonService.setData(this.requestFormData);
            this.router.navigateByUrl('/app/icb/consumer/summary');
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
        this.http.onEnd();
    }

    public termsDialog() {
        this.dialogRef = this.dialog.open(icbtermsDialogComponent, { disableClose: true });
    }

    public privacyDialog() {
        this.dialogRef = this.dialog.open(privacyComponent, { disableClose: true });
    }
    public fileupload() {
        let formData = new FormData();
        this.fileUrl = this.commonService.getIcbImageData() ? this.commonService.getIcbImageData() : [];
        for (let i in this.uploader.queue) {
            this.http.showLoader();
            this.isFileUploaded = true;
            formData.append('file', this.uploader.queue[i]._file);
            let headers = new Headers({ 'apiKey': 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y', 'access-token': this.sessionHandler.getItem('token') });
            this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
            this.Http
                .post(this.URL, formData, { headers: headers })
                .toPromise()
                .then(res => this.setUploadData(res.json()))
                .catch(error => this.handleError(error))
        }
    }
    public setUploadData(res) {

        this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });
        if (res.responseCode == 200) {
            this.isFileUploadError = false;

            this.fileUrl.push({
                "fileName": res.documentName ? res.documentName : '',
                "fileUrl": res.fileUrl
            });
            this.commonService.setIcbImageData(this.fileUrl);
            this.fileUploadResponse = res.message;
            this.viewDocumets();
        } else if (res.responseCode == 400) {
            this.isFileUploadError = true;
            this.fileUploadResponse = res.message;
        }
        this.http.onEnd();
    }

    public handleError(e) {
        console.log('error found -- file upload....' + e);
        this.fileUploadResponse = e;
        this.isFileUploadError = true;
        this.http.onEnd();
    }

    // ----------------------------
    // Language helpers for faults
    // ----------------------------
    private getLabelKey(lang: string): string {
        if (!lang) return 'labelEnglish';
        switch ((lang || '').toLowerCase()) {
            case 'french': return 'labelFrench';
            case 'italian': return 'labelItalian';
            case 'german': return 'labelGerman';
            case 'english':
            default: return 'labelEnglish';
        }
    }

    private getFaultLabel(f: any, lang?: string): string {
        if (!f) return '';
        const key = this.getLabelKey(lang || this.selectedLanguage);
        if (f[key]) return f[key];
        if (f['labelEnglish']) return f['labelEnglish'];
        for (const p of ['labelFrench', 'labelItalian', 'labelGerman', 'labelDutch']) {
            if (f[p]) return f[p];
        }
        return '';
    }

    private applyLanguageToFaults(lang: string) {
        if (!this.faultListOriginal) { this.faultList = []; return; }
        this.faultList = this.faultListOriginal.map(f => {
            const copy = Object.assign({}, f);
            copy.displayLabel = this.getFaultLabel(f, lang);
            return copy;
        });
    }
    // ----------------------------

    public getMagFaultDesc() {
        this.http.getRequest('masterData/v1/getMagMastandFaultItemsDetails')
            .subscribe(
                res => {
                    this.magList = res['magMastList'];
                    this.faultListOriginal = res['faultMastList'] || [];

                    // persist raw list for other components if needed
                    try {
                        this.sessionHandler.saveItem('FaultList', JSON.stringify(this.faultListOriginal));
                    } catch (e) { /* ignore */ }

                    // map and set UI list
                    this.applyLanguageToFaults(this.selectedLanguage);

                    this.http.onEnd();
                },
                err => {
                    if (err && err.status != 0) {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                    }
                    this.http.onEnd();
                });
    }

    viewDocumets() {
        this.uploadedDocList = this.commonService.getIcbImageData()
        if (this.uploadedDocList && this.uploadedDocList.length > 0) {
            this.fileUrl = this.uploadedDocList;
        }
    }

    public saveNewAddress() {
        let tradeId;
        tradeId = this.tradeId;
        this.dialogRef = this.dialog.open(addNewAddressComponent);
        this.dialogRef.componentInstance.tradeId = tradeId;
    }

    public saveNewContact() {
        let tradeId;
        if (this.isAdmin) {
            tradeId = this.requestFormData.tradePartnerId;
        } else {
            tradeId = this.userData.tradePartnerId;
        }
        tradeId = this.tradeId;

        this.dialogRef = this.dialog.open(addNewContactComponent);
        this.dialogRef.componentInstance.tradeId = tradeId;
    }

    navigateDocLink(docUrl) {

        this.viewDocumets();
        docUrl = this.uploadedDocList;
        if (docUrl > 0) {
            this.isdocument = true;
        }
        this.dialogRef = null;
        this.dialogRef = this.dialog.open(ViewImagesDialog);
        this.dialogRef.componentInstance.urlList = docUrl;

        this.http.onEnd();
        this.dialogRef.afterClosed().subscribe((element: any) => {
            let urlList = this.commonService.getIcbImageData()
            this.uploadedDocList = this.commonService.getIcbImageData()
            if (urlList && urlList.length > 0) {
                this.isdocument = true;
            } else {
                this.isdocument = false;
            }
        })
    }

    public SerialValidationCleanup() {
        // placeholder if needed
    }
}

@Component({
    selector: 'view-img',
    template: require('./view-img.component.html'),
    providers: [HttpService, SessionHandler]
})
export class ViewImagesDialog {
    urlSafe: SafeResourceUrl;
    urlList: any = [];
    safeUrlList: any = [];
    oldImageData: any = [];
    newImageData: any = [];
    isdocument: boolean = false;
    uploadedDocList: any;

    constructor(public dialog: MdDialog, private commonService: CommonService, public sanitizer: DomSanitizer) { }
    ngOnInit(): void {
    }

    public fullView(docUrl) {
        window.open(docUrl, "_blank");
    }

    public closeDialog() {
        this.dialog.closeAll();
    }

    public deleteDocument(url) {
        this.newImageData = [];
        this.oldImageData = this.commonService.getIcbImageData();
        for (let i = 0; i < this.oldImageData.length; i++) {
            if (this.oldImageData[i].fileUrl == url) {
                continue;
            } else {
                this.newImageData.push(this.oldImageData[i]);
            }
        }
        this.commonService.setIcbImageData(this.newImageData);
        this.uploadedDocList = this.commonService.getIcbImageData();
        this.urlList = this.commonService.getIcbImageData()
        if (this.urlList.length > 0) {
            this.isdocument = true;
        } else {
            this.closeDialog();
            this.isdocument = false;
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/icb/t2c/data/data.component.ts